import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import TableContainer from "../../../Components/Table/TableContainer";
import TableHeader from "../../../Components/Table/TableHeader";
import TableCell from "../../../Components/Table/TableCell";
import TableSkeleton from '../../../Components/Table/TableSkeleton';
import { useRequestService } from "../../../Services/Request/RequestService";

import styles from "./request.list.module.css";
import Badge from "../../../Components/Badge/Badge";

export default function RequestList() {
  const navigate = useNavigate();
  const { getRequests, requestStatuses } = useRequestService();
  const [requests, setRequests] = useState([]);

  useEffect(() => {
    getRequests().then(result => setRequests(result.Items))
  }, [])

  return (
    <div className={styles.container}>
      <TableContainer>
        <TableHeader>
          <TableCell th="Тип заявления/ID/Участники" />
          <TableCell th="Дата создания" />
          <TableCell th="Номер КУВД/РР" />
          <TableCell th="Описание" />
          <TableCell th="Статус" />
        </TableHeader>

        <tbody className={styles.tbody}>
          {requests?.map((x) =>
          
            <tr onClick={() => navigate(`/request/edit/${x.Id}`)} className={styles.tr} key={x.Id}>
              <TableCell title={x.RegActionName} subtitle={`#${x.RequestNumber} •.`} />
              <TableCell title={x.RegistryDate} />
              <TableCell title={x.Kuvd} subtitle={x.RegistryNumber} />
              <TableCell subtitle={x.Note} />
              <TableCell badge={<Badge type={requestStatuses.find(t => t.code == x.StatusId).style} text={requestStatuses.find(t => t.code == x.StatusId).name}></Badge>} />
            </tr>
          )}
          {requests?.length === 0 &&
            <TableSkeleton col={10} row={5} />
          }
        </tbody>
        <tfoot className={styles.tfoot}>
        </tfoot>
      </TableContainer>
    </div >
  )
}